import Vue from "vue"
import VueGtm from "@gtm-support/vue2-gtm";
import router from "@/routes/router"

if (process.env.VUE_APP_LEVEL === 'production') {
  Vue.use(VueGtm,{
    id: 'GTM-T3FDJX3',
    vueRouter: router
  });
}

